// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionIcon_root__4K2Hn"};